import React from 'react';

import {Flags} from '../flags/Flags';
import {Help} from '../help/Help';
import {Inbox} from '../inbox/Inbox';
import {Login} from '../login/Login';
import {Scratchpad} from '../scratchpad/Scratchpad';
import {Traveler} from '../traveler/Traveler';
import URLSearchParams from 'url-search-params';
import GlobalizationSelector from '@homeaway/react-globalization-selector';

import './Nav.less';

export class Nav extends React.Component {
    handleChangeGlobalSelector = (locale, siteUrl, currency) => {
        let countryCode = locale.split('_')[1].toLowerCase();
        let origin;
        let params;

        if (window && window.location) {
            if (countryCode === this.props.countryCode) {
                origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
                params = new URLSearchParams(window.location.search);
            } else {
                origin = siteUrl.replace(/\/$/, '');
                params = new URLSearchParams();
            }

            params.set('gx-locale', locale);
            params.set('gx-currency', currency);

            window.location.assign(`${origin}?${params.toString()}`);
        }
    };

    renderGlobalSelector() {
        if (!this.props.renderCountryLanguageSelector && !this.props.renderCurrencySelector) {
            return null;
        }

        return (
            <GlobalizationSelector
                className="site-header-nav__dropdown"
                {...this.props.globalizationSelector}
                countryCode={this.props.countryCode}
                currencyCode={this.props.currencyCode}
                languageCode={this.props.languageCode}
                onGlobalSelectorChange={this.handleChangeGlobalSelector}
                renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                renderCurrencySelector={this.props.renderCurrencySelector}
            />
        );
    }

    renderExtraNav() {
        if (!this.props.extraNav) {
            return null;
        }

        if (!this.props.extraNav.items) {
            return null;
        }

        return this.props.extraNav.items.map((item, index) => (
            <a
                className={`site-header-nav__link ${item.cssClass}`}
                data-bypass="true"
                href={item.link}
                key={index}
            >{item.text}</a>
        ));
    }

    renderFlags() {
        if (!this.props.flags) {
            return null;
        }

        return (
            <Flags {...this.props.flags} />
        );
    }

    renderHelp() {
        if (!this.props.help) {
            return null;
        }

        return (
            <Help {...this.props.help} />
        );
    }

    renderInbox() {
        if (!this.props.traveler || !this.props.inbox) {
            return null;
        }

        return (
            <a className="site-header-nav__link" data-bypass="true" href={this.props.inbox.link}>
                <Inbox {...this.props.inbox} />
            </a>
        );
    }

    renderInternalTools() {
        if (!this.props.internalTools) {
            return null;
        }

        return this.props.internalTools;
    }

    renderLogin() {
        if (!this.props.login) {
            return null;
        }

        return (
            <Login {...this.props.login} />
        );
    }

    renderScratchpad() {
        if (!this.props.scratchpad) {
            return null;
        }

        return (
            <a className="site-header-nav__link" data-bypass="true" href={this.props.scratchpad.link}>
                <Scratchpad {...this.props.scratchpad} />
            </a>
        );
    }

    renderTraveler() {
        if (!this.props.traveler) {
            return null;
        }

        return (
            <Traveler {...this.props.traveler} />
        );
    }

    render() {
        return (
            <div className="site-header-nav" role="navigation">
                {this.renderScratchpad()}
                {this.renderInbox()}
                {this.renderLogin()}
                {this.renderTraveler()}
                {this.renderHelp()}
                {this.renderExtraNav()}
                {this.renderInternalTools()}
                {this.props.feedbackComponent &&
                <div className="site-header-feedback">
                    {this.props.feedbackComponent}
                </div>
                }
                {this.renderFlags()}
                {this.renderGlobalSelector()}
            </div>
        );
    }
}
